import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteTrustRule } from "./api";

// DELETE выводит правило из работы (is_active=false), не удаляет строку —
// таблица покажет её неактивной (бейдж), не уберёт из списка. Инвалидируем
// только список правил. applications-history не трогаем: строка и записи
// журнала остаются на backend, аудит не теряется.
export function useDeleteTrustRule(): ReturnType<
  typeof useMutation<void, Error, string>
> {
  const queryClient = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: (ruleId) => deleteTrustRule(ruleId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["trustRules"],
      });
    },
  });
}
